import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UIElementModule } from 'src/app/core';
import { DashboardService } from './dashboard.service'

import { Dashboard } from './dashboard'
import { ExerciceModule } from 'src/app/exercice';
import { TrainingModule } from 'src/app/training';

const declareAndExport = [
	Dashboard,
]

@NgModule({
	imports: [RouterModule, UIElementModule, TrainingModule],
	declarations: [declareAndExport],
	exports: [declareAndExport],
	providers: [DashboardService]
})
export class DashboardModule { }
